import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolestatisticsComponent } from './pages/rolestatistics/rolestatistics.component';
import { OrderplanningComponent } from './pages/orderplanning/orderplanning.component';
import { AcrolesComponent } from './pages/acroles/acroles.component';
import { ObserverlistComponent } from './pages/observerlist/observerlist.component';
import { ObserverappointmentsComponent } from './pages/observerappointments/observerappointments.component';
import { ReportingTableComponent } from './partials/reporting-table/reporting-table.component';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoRootModule } from '../transloco/transloco-root.module';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../shared/shared.module';
import { MomentModule } from 'ngx-moment';
import { CoreModule } from 'projects/core/src/public-api';
import { ToolboxComponent } from './pages/toolbox/toolbox.component';
import { ReportingDateSelectorComponent } from './partials/reporting-date-selector/reporting-date-selector.component';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';

@NgModule({
  declarations: [
    RolestatisticsComponent,
    OrderplanningComponent,
    AcrolesComponent,
    ObserverlistComponent,
    ObserverappointmentsComponent,
    ReportingTableComponent,
    ToolboxComponent,
    ReportingDateSelectorComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    CoreModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TranslocoRootModule,
    CardModule,
    TableModule,
    ButtonModule,
    DialogModule,
    TagModule,
    MomentModule
  ]
})
export class ReportingsModule { }
